import HBIcon from "@/components/HBIcon";
import Image from "@/components/Image";
import { TrackerA } from "@/components/Tracker";
import imageUrl from "@/utils/imageUrl";
import classNames from "classnames";
import { HTMLAttributes, useMemo } from "react";
import { Case, Default, Switch } from "react-if";
import styles from "./cover.module.less";
enum pinType {
  overlong = 1, // 超长竖图
  long, // 竖图
  square, // 方图
  short, // 横图
}

export enum Radius {
  all = "all", // 图片全部圆角
  outer = "outer", // 图片外圆角
}

export enum ImageMargin {
  small = "small", // 图片间距小
  normal = "normal", // 图片间距大
}

interface CoverProps extends HTMLAttributes<HTMLAnchorElement> {
  pinCount: number;
  pins: IPin[];
  filter: {
    id: number;
    name: string;
  };
  activeFestival?: string;
  radius?: Radius;
  margin?: ImageMargin;
  link?: string;
  title?: string;
}

export default function Cover(props: CoverProps) {
  const {
    title,
    pinCount,
    pins,
    filter,
    activeFestival,
    radius = "all",
    margin = "normal",
    link,
    ...rest
  } = props;

  // 根据图片宽高选择不同类型
  const chooseImgType = (width, height) => {
    let proportion = width / height;
    if (proportion < 0.56) {
      return pinType.overlong;
    } else if (proportion < 0.8) {
      return pinType.long;
    } else if (proportion > 1.5) {
      return pinType.short;
    } else {
      return pinType.square;
    }
  };
  const imgType = useMemo(() => {
    if (pins?.length) {
      const { width, height } = pins[0].file;
      return chooseImgType(width, height);
    }
    return pinType.long;
  }, [pins]);

  return (
    //eslint-disable-next-line react/jsx-no-target-blank
    <TrackerA
      className={styles.content}
      href={
        link || `/calendars/${activeFestival}?filter_ids=festival-${filter?.id}`
      }
      target={"_blank"}
      {...rest}
    >
      <div
        className={classNames(styles.cover, {
          [styles.outerRadius]: radius === Radius.outer,
          [styles.smallMargin]: margin === ImageMargin.small,
        })}
      >
        <Switch>
          <Case condition={imgType === pinType.short}>
            <div className={styles.short}>
              {pins?.slice(0, 2).map((item) => {
                return (
                  <div key={item.pin_id} className={styles.img}>
                    <Image
                      src={imageUrl(item.file, { width: 240 })}
                      alt=""
                    ></Image>
                  </div>
                );
              })}
            </div>
          </Case>
          <Case condition={imgType === pinType.square}>
            <div className={styles.square}>
              {pins?.slice(0, 4).map((item) => {
                return (
                  <div key={item.pin_id} className={styles.img}>
                    <Image
                      src={imageUrl(item.file, { width: 109, rect: "sq" })}
                      alt=""
                    ></Image>
                  </div>
                );
              })}
            </div>
          </Case>
          <Default>
            <div className={styles.long}>
              {pins?.slice(0, 3).map((item, index) => {
                return (
                  <div
                    key={item.pin_id}
                    className={classNames(styles.img, {
                      [styles.longImg]: imgType === pinType.long,
                    })}
                  >
                    <Image
                      src={imageUrl(item.file, {
                        width: index == 0 ? 131 : 87,
                      })}
                      alt=""
                    ></Image>
                  </div>
                );
              })}
            </div>
          </Default>
        </Switch>
      </div>
      <div className={styles.footer}>
        <div className={styles.left} title={title || filter?.name}>
          {title || filter?.name}
        </div>
        <div className={styles.right}>
          {pinCount}张
          <HBIcon type="ic_chevron_right" className={styles.icon} />
        </div>
      </div>
    </TrackerA>
  );
}
